import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  KEY = 'selected_lang';
  SUPPORTED_LANGS = ['en', 'de', 'ja', 'es', 'fr'];

  constructor(private translate: TranslateService) {
    this.init();
  }

  private init(): void {
    this.translate.addLangs(this.SUPPORTED_LANGS);
  this.translate.setDefaultLang('en');

  const savedLang = localStorage.getItem(this.KEY);
  const browserLang = this.translate.getBrowserLang() ?? 'en';

  let langToUse: string;

  if (savedLang && this.SUPPORTED_LANGS.includes(savedLang)) {
    langToUse = savedLang;
  } else if (this.SUPPORTED_LANGS.includes(browserLang)) {
    langToUse = browserLang;
  } else {
    langToUse = 'en';
  }

  this.translate.use(langToUse);
  localStorage.setItem(this.KEY, langToUse);
  document.documentElement.lang = langToUse;
  }

  setLang(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem(this.KEY, lang);
    document.documentElement.lang = lang;
  }

  get currentLang(): string {
    return this.translate.currentLang ?? 'en';
  }
}
